module.exports = ".char_thumb{\r\n  height:5em\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/character/character-sheet/character-sheet-header/character-sheet-header.component.css
// module id = ./src/app/character/character-sheet/character-sheet-header/character-sheet-header.component.css
// module chunks = main